import { isNativeMobileDeviceType } from "../../../constants";
import type { ViewerDeviceRuntime } from "../../../types";
import { MESSAGE } from "./constants";

export function getJournalBlockedMessage(
  viewerDevice: ViewerDeviceRuntime,
): string | null {
  if (!viewerDevice.isOnline()) {
    return MESSAGE.network_error;
  }
  if (isNativeMobileDeviceType(viewerDevice.deviceType)) {
    return MESSAGE.mobile_error;
  }
  return null;
}
